import React from 'react';

const DateRender = ({ value }) => {
    return <span>{value || '-'}</span>;
};

export default DateRender;
